import React from "react"
import { Box, Flex, Text } from "@chakra-ui/react"
import Icon from "components/elements/Icon"
import Link from "components/elements/Link"
import { DioboxEvent } from "sharedTypes"
import useResolvedTranslations from "pages/EventShow/Settings/LanguageTemplates/useResolvedTranslations"
import PreviewCard from "./PreviewCard"

type Props = {
  event: DioboxEvent
  /** The languageTemplateId of the form currently being previewed, if any — see
   * PreviewFrameWithBranding's `languageTemplateId` prop for why this matters. */
  languageTemplateId?: string | null
}
const MapLink = ({
  event: {
    portalShowMap,
    portalMapUrl,
    portalPrimaryColor,
  },
  languageTemplateId,
}: Props) => {
  const { viewMap } = useResolvedTranslations(languageTemplateId)

  return (
    <PreviewCard>
      <Flex w="full" py={5} justifyContent="center">
        {portalShowMap && (
          <Box width="fit-content">
            <Link href={portalMapUrl} isExternal>
              <Text textAlign="center" fontSize="lg" fontWeight="semibold" color={portalPrimaryColor}>
                <Icon icon="event-where" color={portalPrimaryColor} mr={1} />{viewMap}
              </Text>
            </Link>
          </Box>
        )}
      </Flex>
    </PreviewCard>
  )
}

export default MapLink
